/* eslint-disable max-len */
// @flow
export const IS_DEVEL = process.env.NODE_ENV !== 'production';

export const MAKO_ANALYTICS_PAGE_IDS = {
	MAIN: 'HP',
	GALLERY: 'gallery',
	RESULT: 'result',
};

export const SHARE_CONSTANTS = {
	WHATSAPP: 'WhatsApp',
	FACEBOOK: 'Facebook',
	EMAIL: 'Email',
};

export const COLLECTIONS = {
	CHECKLISTS: 'checklists',
	GALLERYITEMS: 'galleryItems',
	VOTES: 'votes',
	USERS: 'users',
	EMAILSDATA: 'email',
	REGISTREDUSERSVOTES: 'registred-users-votes',
};
